import { Box, Divider, Typography } from "@mui/material";
import { FC } from "react";

import Loading from "web/Layout/Common/Loading";
import __ from "web/Layout/Translations";

import { Classes } from "web/types/Common";
import {
  SubscriptionCheckoutSteps,
  SubscriptionCheckoutStepsTemplateProps,
  SubscriptionGroups,
} from "web/types/Subscription";

import TotalsAndButtonBox from "./totalsAndButtonBox";

export interface ICheckoutSubscriptionAsideProps
  extends Omit<SubscriptionCheckoutStepsTemplateProps, "prevStep"> {
  classes?: Classes;
  group?: SubscriptionGroups;
  prevStep?: () => void;
}

const CheckoutSubscriptionAside: FC<ICheckoutSubscriptionAsideProps> = ({
  step,
  group,
  totals,
  totalsIsLoading = false,
  totalsError = "",
  isNextStepDisabled = false,
  nextStep,
  prevStep,
}) => {
  const isLastStep = step === SubscriptionCheckoutSteps.SUMMARY;

  const totalsProps = {
    totalsIsLoading,
    totals,
    totalsError,
    nextStep,
    prevStep,
    isNextStepDisabled,
    isLastStep,
  };

  return (
    <Box component="aside">
      <Box>
        <Typography variant="h3" data-t1="summary_label">
          {__("Podsumowanie")}
        </Typography>
      </Box>

      <Divider sx={{ m: "16px 0" }} />

      {isLastStep && totalsIsLoading ? (
        <Loading />
      ) : (
        <TotalsAndButtonBox step={step} group={group} {...totalsProps} />
      )}
    </Box>
  );
};

export default CheckoutSubscriptionAside;
